module.exports = __webpack_public_path__ + "static/media/graveyardfull.feab21bb.png";